/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateParameterCombinationDto } from './CreateParameterCombinationDto';
import {
    CreateParameterCombinationDtoFromJSON,
    CreateParameterCombinationDtoFromJSONTyped,
    CreateParameterCombinationDtoToJSON,
} from './CreateParameterCombinationDto';

/**
 * 
 * @export
 * @interface CreateParameterCombinationTableDto
 */
export interface CreateParameterCombinationTableDto {
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationTableDto
     */
    combinationSetId?: string;
    /**
     * 
     * @type {Array<CreateParameterCombinationDto>}
     * @memberof CreateParameterCombinationTableDto
     */
    combinations?: Array<CreateParameterCombinationDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateParameterCombinationTableDto
     */
    $type?: CreateParameterCombinationTableDtoTypeEnum;
}


/**
 * @export
 */
export const CreateParameterCombinationTableDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsCreateParameterCombinationTableDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.CreateParameterCombinationTableDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateParameterCombinationTableDtoTypeEnum = typeof CreateParameterCombinationTableDtoTypeEnum[keyof typeof CreateParameterCombinationTableDtoTypeEnum];


/**
 * Check if a given object implements the CreateParameterCombinationTableDto interface.
 */
export function instanceOfCreateParameterCombinationTableDto(value?: unknown): value is CreateParameterCombinationTableDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateParameterCombinationTableDtoTypeEnum)[0];
}

export function CreateParameterCombinationTableDtoFromJSON(json: any): CreateParameterCombinationTableDto {
    return CreateParameterCombinationTableDtoFromJSONTyped(json, false);
}

export function CreateParameterCombinationTableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateParameterCombinationTableDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'combinationSetId': !exists(json, 'combinationSetId') ? undefined : json['combinationSetId'],
        'combinations': !exists(json, 'combinations') ? undefined : (json['combinations'] === null ? null : (json['combinations'] as Array<any>).map(CreateParameterCombinationDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateParameterCombinationTableDtoToJSON(value?: CreateParameterCombinationTableDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'combinationSetId': value.combinationSetId,
        'combinations': value.combinations === undefined ? undefined : (value.combinations === null ? null : (value.combinations as Array<any>).map(CreateParameterCombinationDtoToJSON)),
        '$type': value.$type,
    });
}

